// extracted by mini-css-extract-plugin
module.exports = {"error404":"ErrorContent404_error404__aA4bf","enContent":"ErrorContent404_enContent__PmBsr","enHeader":"ErrorContent404_enHeader__1LhOH"};